interface MediaItem {
  title: string;
  desc: string;
  tag: string;
  imageUrl: string;
  imageAlt: string;
}

const mediaItems: MediaItem[] = [
  {
    title: '《霸道总裁的契约新娘》热播中',
    desc: '都市恋爱题材人气之作，每周三、六更新，累计阅读破亿的韩漫经典。',
    tag: '韩漫热榜',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylish%20Korean%20manhwa%20style%20illustration%20of%20a%20romantic%20drama%20scene%2C%20elegant%20female%20character%20in%20a%20modern%20office%20setting%20with%20warm%20ambient%20lighting%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20clean%20composition%20with%20gentle%20gradients%2C%20webtoon%20aesthetic%2C%20editorial%20quality%20digital%20art%20with%20warm%20atmosphere&width=800&height=450&seq=media-card-01&orientation=landscape',
    imageAlt: '霸道总裁的契约新娘韩漫推荐',
  },
  {
    title: '《剑道至尊》全网同步连载',
    desc: '东方玄幻大作，精美画风搭配跌宕剧情，国漫崛起代表作品之一。',
    tag: '国漫精选',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20illustration%20of%20a%20martial%20arts%20fantasy%20scene%2C%20a%20warrior%20with%20flowing%20robes%20wielding%20a%20glowing%20sword%20in%20a%20misty%20mountain%20landscape%2C%20ink%20wash%20painting%20aesthetic%20blended%20with%20modern%20digital%20coloring%2C%20warm%20amber%20and%20jade%20green%20accents%2C%20dramatic%20composition%20with%20flowing%20energy%20effects%2C%20high%20quality%20illustration&width=800&height=450&seq=media-card-02&orientation=landscape',
    imageAlt: '剑道至尊国漫推荐',
  },
  {
    title: '《放学后的秘密》甜蜜上线',
    desc: '校园纯爱日漫风格，温馨治愈的青春物语，每话都让人心动不已。',
    tag: '日漫精选',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20illustration%20of%20a%20sweet%20school%20romance%20scene%2C%20two%20high%20school%20students%20walking%20under%20cherry%20blossom%20trees%20at%20sunset%2C%20warm%20golden%20light%20filtering%20through%20the%20branches%2C%20soft%20pastel%20color%20palette%20with%20pink%20and%20amber%20tones%2C%20gentle%20and%20dreamy%20atmosphere%2C%20clean%20linework%20in%20anime%20style%2C%20editorial%20quality%20digital%20art&width=800&height=450&seq=media-card-03&orientation=landscape',
    imageAlt: '放学后的秘密日漫推荐',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">精选推荐</h2>
          <p className="text-sm text-foreground-500">热门漫画抢先看，每日更新不重样</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-primary-700">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/80 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-medium text-sm text-foreground-900 mb-1.5 line-clamp-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}